import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import ListIcon from "@mui/icons-material/List";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
  Typography,
  IconButton,
} from "@mui/material";

import { TableCell } from "components/TableCell";
import { Tooltip } from "components/Tooltip";
import { LinkText } from "components/utility/LinkText";
import { VSpace } from "components/utility/VSpace";

import { i18n } from "services/i18nService";
import { formatDateTimeToDateTimeString } from "services/utility/formatting";

import { usePrivileges } from "hooks/usePrivileges";

import { openModal } from "globalState/modalSlice";

import { getObjectFromTypeString } from "appConstants";

export function RecentTransactionsList(props) {
  const { records } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { canEditObjectType } = usePrivileges();

  function openEditModal(objectType, id) {
    dispatch(openModal({ objectType, modalProps: { id } }));
  }

  if (!records) {
    return null;
  }

  return (
    <>
      <Typography variant="h3">{i18n("global.RecentTransactions")}:</Typography>
      <VSpace space={1} />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "14rem", padding: "0.5rem" }}>
                {i18n("columns.Type")}
              </TableCell>
              <TableCell>{i18n("columns.ReferenceNumber")}</TableCell>
              <TableCell />

              <TableCell>{i18n("columns.TimeCreatedEdited")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {records?.map((record, index) => {
              const { fullString } = getObjectFromTypeString(record.type);
              return (
                <TableRow key={index}>
                  <TableCell sx={{ padding: "0.5rem" }}>
                    {i18n(`objectType.${fullString}.Sentence`)}
                  </TableCell>
                  <TableCell>
                    {record.linkedObjectId && canEditObjectType(fullString) ? (
                      <LinkText
                        onClick={() => {
                          openEditModal(fullString, record.linkedObjectId);
                        }}
                      >
                        {record.objectValue}
                      </LinkText>
                    ) : (
                      <>{record.objectValue}</>
                    )}
                  </TableCell>
                  <TableCell>
                    {record.linkedObjectId && (
                      <Tooltip title={i18n("tooltip.ClickToGoToList")}>
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() =>
                            navigate(
                              `/${fullString}?id=${record.linkedObjectId}`
                            )
                          }
                        >
                          <ListIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                  <TableCell>
                    {formatDateTimeToDateTimeString(record.eventDateTime)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <VSpace space={1} />
    </>
  );
}
